module.exports = __webpack_public_path__ + "static/media/Antwerp.ef819870.jpg";